import _objectSpread from "/usr/app/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import React from "react";
var __jsx = React.createElement;
import StepperContent from "./StepperContent";
import { DynamicFormProvider } from "../../context/ScreenContext";
import data_ar from "@data/finance-eligibility/finance_eligibility_data_ar.json";
import data_en from "@data/finance-eligibility/finance_eligibility_data_en.json";
import { useEffect, useState } from "react";
import { useLang } from "@/common/Contexts/LanguageContext";
import Loader from "@componentsShared/Loader/Loader";
var Stepper = function Stepper(_ref) {
  var condition_id = _ref.condition_id;
  var lang = useLang();
  var _useState = useState(null),
    stepData = _useState[0],
    setStepData = _useState[1];
  var _useState2 = useState(1),
    initialStepId = _useState2[0],
    setInitialStepId = _useState2[1];
  useEffect(function () {
    if (lang === "ar") {
      setStepData(data_ar);
    } else {
      setStepData(data_en.map(function (step) {
        return _objectSpread(_objectSpread({}, step), {}, {
          key: step.key.replace("_en", "")
        });
      }));
    }
  }, [lang]);
  useEffect(function () {
    if (condition_id && stepData) {
      if (parseInt(condition_id) === 1) {
        var work_sector_new_screen = stepData === null || stepData === void 0 ? void 0 : stepData.find(function (step) {
          return step.key === "work_sector_new";
        });
        setInitialStepId(work_sector_new_screen === null || work_sector_new_screen === void 0 ? void 0 : work_sector_new_screen.id);
      }
      if (parseInt(condition_id) === 0) {
        var work_sector_used_screen = stepData === null || stepData === void 0 ? void 0 : stepData.find(function (step) {
          return step.key === "work_sector_used";
        });
        setInitialStepId(work_sector_used_screen === null || work_sector_used_screen === void 0 ? void 0 : work_sector_used_screen.id);
      }
    } else {
      var car_condition_screen = stepData === null || stepData === void 0 ? void 0 : stepData.find(function (step) {
        return step.key === "car_condition";
      });
      setInitialStepId(car_condition_screen === null || car_condition_screen === void 0 ? void 0 : car_condition_screen.id);
    }
  }, [stepData, condition_id]);
  if (!stepData) {
    return /*#__PURE__*/React.createElement(Loader, null);
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, stepData && /*#__PURE__*/React.createElement(DynamicFormProvider, {
    steps: stepData,
    initialStepId: initialStepId
  }, /*#__PURE__*/React.createElement(StepperContent, null)));
};
export default Stepper;